// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:35:52

export default {
  "id": "the-grench-couple-holiday-dress-up",
  "slug": "the-grench-couple-holiday-dress-up",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/22f236fbc80f489c906970a2ef2e8051-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/22f236fbc80f489c906970a2ef2e8051/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "The Grench Couple Holiday Dress up",
      "description": "Get ready to immerse yourself in a delightful holiday-themed game with The Grench Couple Holiday Dress Up! This unique dress-up game combines festive fun with creative fashion choices, letting you design the perfect holiday outfits for the Grench and his partner. Whether you’re a fan of dressing up games or just love the Grench’s mischievous charm, this game promises a memorable and entertaining experience.",
      "instructions": "Left Mouse Button Click",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "christmas",
        "cutedressup",
        "girls",
        "girlsdressup"
      ]
    },
    "zh-CN": {
      "title": "格伦奇夫妇假日装扮",
      "description": "准备好沉浸在这款愉快的节日主题游戏《Grench夫妇节日装扮》中！这款独特的装扮游戏将节日乐趣与创意时尚选择相结合，让你为Grench和他的伴侣设计完美的节日装扮。无论你是装扮游戏的粉丝还是仅仅喜欢Grench的顽皮魅力，这款游戏都承诺带来难忘且有趣的体验。",
      "instructions": "左鼠标按钮点击",
      "genres": [
        "装扮"
      ],
      "tags": [
        "圣诞节",
        "可爱装扮",
        "女孩",
        "女孩装扮"
      ]
    },
    "zh-TW": {
      "title": "格倫奇夫婦度假打扮",
      "description": "準備好沉浸在一款令人愉快的節慶主題遊戲《格倫奇夫妻節日打扮》吧！這款獨特的打扮遊戲結合了節日樂趣與創意時尚選擇，讓你為格倫奇和他的伴侶設計完美的節日造型。無論你是打扮遊戲的粉絲還是喜愛格倫奇的淘氣魅力，這款遊戲保證會帶來難忘且愉悅的體驗。",
      "instructions": "左鍵點擊",
      "genres": [
        "装扮"
      ],
      "tags": [
        "聖誕節",
        "可愛装扮",
        "女孩",
        "女孩装扮"
      ]
    },
    "zh-HK": {
      "title": "格倫契夫婦假日打扮",
      "description": "準備好沉浸於一場愉快的節日主題遊戲《格倫夫夫妻節日打扮》！這款獨特的打扮遊戲結合了節日樂趣與創意時尚選擇，讓你為格倫夫和他的伴侶設計完美的節日裝扮。無論你是打扮遊戲的粉絲還是喜愛格倫夫的淘氣魅力，這款遊戲都保證帶來難忘而有趣的體驗。",
      "instructions": "左鍵按鈕點擊",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "聖誕節",
        "可愛打扮",
        "女孩",
        "女孩打扮"
      ]
    },
    "ja": {
      "title": "グレンチ夫妻の休暇ドレスアップ",
      "description": "グレンチカップルハリウッドドレスアップで、楽しい休日テーマのゲームに没頭しましょう！このユニークなドレスアップゲームは、お祭りの楽しさとクリエイティブなファッションの選択を組み合わせ、グレンチとそのパートナーのための完璧な休日コーディネートをデザインすることができます。ドレスアップゲームが大好きな人も、グレンチのいたずら好きなキャラクターが大好きな人も、このゲームは忘れられない楽しい体験を約束します。",
      "instructions": "左マウスボタンクリック",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "クリスマス",
        "可愛いドレスアップ",
        "ガールズ",
        "ガールズドレスアップ"
      ]
    },
    "ko": {
      "title": "그렌치 커플 휴가 드레스업",
      "description": "The Grench Couple Holiday Dress Up!를 통해 즐거운 휴가 주제 게임에 자신을 빠르게 몰입해보세요! 이 독특한 드레스업 게임은 풍요로운 재미와 창의적인 패션 선택을 결합하여, Grench와 그 파트너의 완벽한 휴가 옷차림을 디자인할 수 있게 합니다. 드레스업 게임을 좋아하시거나 Grench의 기발한 매력을 사랑하시는 분들께, 이 게임은 기억에 남는 재미있는 경험을 약속합니다.",
      "instructions": "좌클릭",
      "genres": [
        "의상 차려입기"
      ],
      "tags": [
        "크리스마스",
        "귀여운 드레스업",
        "소녀",
        "소녀 드레스업"
      ]
    },
    "fr": {
      "title": "Le Costume de Vacances pour le Couple Grench",
      "description": "Préparez-vous à vous immerger dans un jeu de thème de fête délicieux avec The Grench Couple Holiday Dress Up ! Ce jeu de déguisement unique combine le plaisir festif avec des choix de mode créatifs, vous permettant de concevoir les tenues de fête parfaites pour Grench et son partenaire. Que vous soyez fan des jeux de déguisement ou que vous aimiez le charme malicieux de Grench, ce jeu promet une expérience mémorable et amusante.",
      "instructions": "Clic gauche de la souris",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "Noël",
        "déguisement-coupage-couleur",
        "filles",
        "déguisement-de-filles"
      ]
    }
  }
};
